import React, { useState } from "react";
import {
  supportSectionBody,
  supportSectionHeader,
  supportSectionShell,
} from "./supportStyles";

/**
 * Shared collapsible section shell for Support patient review.
 */
const SupportSection = ({
  title,
  summary,
  defaultOpen = false,
  headerRight,
  onToggle,
  children,
  contentClassName = "px-4 py-4",
}) => {
  const [open, setOpen] = useState(defaultOpen);

  const toggleOpen = () => {
    setOpen((value) => {
      const next = !value;
      onToggle?.(next);
      return next;
    });
  };

  return (
    <div className={supportSectionShell}>
      <button
        type="button"
        onClick={toggleOpen}
        aria-expanded={open}
        className={supportSectionHeader}
      >
        <span className="text-gray-500 text-xs shrink-0 w-3 text-center" aria-hidden>
          {open ? "▼" : "▶"}
        </span>
        <h3 className="font-semibold text-gray-900 text-sm shrink-0">{title}</h3>
        {!open && summary && (
          <span className="text-xs text-gray-600 truncate min-w-0 flex-1">{summary}</span>
        )}
        {open && <span className="flex-1" />}
        {headerRight && <span className="shrink-0">{headerRight}</span>}
      </button>
      {open && (
        <div className={`${supportSectionBody} ${contentClassName}`}>{children}</div>
      )}
    </div>
  );
};

export default SupportSection;
